import NavigationLink from 'ggApp/shared/common/NavigationLink';
import styled, { css } from 'styled-components';
import { SonntagIcon } from '@getgrover/ui';
import { SmallHeadline } from 'ggApp/shared/common/Typography';

const Wrap = styled(NavigationLink)`
    position: relative;
    height: 48px;
    display: flex;
    align-items: center;
    padding: 0 ${({ theme }) => theme.spacers.L};
    ${({ theme }) => theme.superQuery.all.and.minWidth.desktopMin.css`
        &:first-child {
            border-top-left-radius: 8px;
        }
        &:last-child {
            border-bottom-left-radius: 8px;
        }
    `}
`;

const Background = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    margin-left: -16px;

    background: ${({ isActiveCategory, theme }) => (isActiveCategory ? theme.colors["Level 1"] : theme.colors.ElementBackground)};
    border-radius: inherit;
    &:hover,
    &:focus,
    &:active {
      background: ${({ theme }) =>  theme.colors["Level 1"]};

    }
`;

const Icon = styled(SonntagIcon)`
 margin-right: ${({ theme }) => theme.spacers.L};
 position: relative;
 fill: ${({ isActiveCategory, theme }) => isActiveCategory ? theme.colors.Foreground : theme.colors['Level 5']};
 `;

const Name = styled.span`
    position: relative;
    color:  ${({ isActiveCategory, theme }) => isActiveCategory ? theme.colors.Foreground : theme.colors.Foreground};
    ${({ theme }) => css(theme.typography.SmallHeadline)}
`;

const SubcategoryLink = styled(NavigationLink)`
    display: none;
`;

export {
    Wrap,
    Background,
    Icon,
    Name,
    SubcategoryLink,
};
